import BaseModelAPI from '../BaseModelAPI';

export default class ArchivedDocumentList extends BaseModelAPI {

	static entity = 'archiveddocumentlist'
	static entityName = 'archiveddocument';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
